import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c1a79e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rework" }
const _hoisted_2 = { class: "rework_list" }
const _hoisted_3 = {
  key: 0,
  class: "rework_list_item"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前工厂", -1))
const _hoisted_5 = { class: "rework_list_item_right" }
const _hoisted_6 = { class: "black" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返工类型", -1))
const _hoisted_8 = { class: "rework_list_item_right" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "预计生产日期", -1))
const _hoisted_10 = { class: "rework_list_item_right" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返工返修工序", -1))
const _hoisted_12 = { class: "rework_list_item_right" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返工返修原因", -1))
const _hoisted_14 = { class: "rework_list_item_right" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客返单号", -1))
const _hoisted_16 = { class: "rework_list_item_right" }
const _hoisted_17 = {
  key: 2,
  class: "rework_list_item"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客返客户", -1))
const _hoisted_19 = { class: "rework_list_item_right" }
const _hoisted_20 = { class: "black" }
const _hoisted_21 = { class: "rework_qd" }
const _hoisted_22 = { class: "rework_qd_title" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "x" }, null, -1))
const _hoisted_24 = { class: "rework_qd_item" }
const _hoisted_25 = { class: "rework_qd_item_i" }
const _hoisted_26 = { class: "black" }
const _hoisted_27 = { class: "black" }
const _hoisted_28 = { class: "rework_qd_item_i" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "物料信息：", -1))
const _hoisted_30 = { class: "rework_qd_item_i" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "批次号：", -1))
const _hoisted_32 = { class: "rework_qd_item_i" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "生产工序：", -1))
const _hoisted_34 = {
  key: 1,
  class: "rework_qd_item1"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "zw" }, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"22px"} }, null, -1))

import { onMounted, reactive, ref } from 'vue'
    import { useRoute, useRouter } from "vue-router"
    import { gsdate } from "@/utils/utils"
    import { Toast } from 'vant'
    import { useStore } from "vuex"
    import { checkFGFXList, getBarcodeContent, getListByCondition, allData, createSingle, productesGroups } from '@/apis/WorkOrderAPI'
    import { QRCodeType } from "@/enum"

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    // 表单数据
    let form = reactive({
        factory: '',
        factoryId: '',
        type: '0',
        typeName: '工序返工',
        date: '',
        process: '',
        processName: '',
        reason: '详见产品手写标签',
        reasonName: '详见产品手写标签',
        clientName: '',
        single: '',
        singleName: ''
    })

    // 返工返修清单
    let list = ref<Array<any>>([])

    // 类型
    const columns = [{ text: '工序返工', id: '0' }]

    // 工序
    const columns1 = ref<Array<any>>([])

    // 原因
    const columns2 = ref<Array<any>>([])

    // 单号
    const columns3 = ref<Array<any>>([])

    let show = ref<boolean>(false)

    let openGX = ref<boolean>(false)

    let openYY = ref<boolean>(false)

    let openDH = ref<boolean>(false)

    let openDate = ref<boolean>(false)

    let openCode = ref<boolean>(false)

    // 获取明天日期
    const tomorrow = (): string => {
        let day3 = new Date()
        day3.setTime(day3.getTime() + 24 * 60 * 60 * 1000)
        return day3.getFullYear() + "/" + (day3.getMonth() + 1) + "/" + day3.getDate()
    }

    const minDate: any = new Date(tomorrow())

    const maxDate: any = new Date(new Date().getFullYear() + 1, 12, 30)

    // 提交申请
    const submit = async () => {
        if (!form.date) return Toast.fail({ message: '预计生产日期不能为空' })
        if (!form.process) return Toast.fail({ message: '返工返修工序不能为空' })
        if (!form.reason) return Toast.fail({ message: '返工返修原因不能为空' })
        let arrId: Array<number> = []
        list.value.forEach((element: any) => {
            arrId.push(element.id)
        })
        let res = await createSingle({
            factoryId: list.value[0].pmodelOrgId,
            type: form.type,
            planDate: form.date,
            backProcedureId: form.process,
            content: form.reasonName,
            applianceIdList: arrId
        })
        if (res.code === 200) {
            Toast.success({ message: '申请成功', forbidClick: true, duration: 2000 })
            setTimeout(() => {
                router.go(-1)
            }, 2000)
        }
    }

    // 删除指定工装清单
    const dele = (i: number): void => {
        if (list.value.length === 1) {
            Toast.fail({ message: '至少保留一项工装' })
            return
        }
        list.value.splice(i, 1)
    }

    // 确认选择日期
    const onConfirmDate = (values: any) => {
        form.date = gsdate(values)
        openDate.value = false
    };

    // 类型确认
    const onConfirm = (value: any) => {
        form.type = value.id
        form.typeName = value.text
        show.value = false
    };

    const onCancel = () => {
        show.value = false
    }

    // 工序确认
    const onConfirm1 = (value: any, index: number) => {
        form.processName = value.text
        form.process = value.id
        openGX.value = false
    };

    const onCancel1 = () => {
        openGX.value = false
    }

    // 不良原因
    const onConfirm2 = (value: any, index: number) => {
        form.reasonName = value.text
        form.reason = value.id
        openYY.value = false
    };

    const onCancel2 = () => {
        openYY.value = false
    }

    const onConfirm3 = (value: any, index: number) => {
        console.log(`当前值: ${value}, 当前索引: ${index}`);
    };

    const onCancel3 = () => {
        openDH.value = false
    }

    const closePopup = (): void => {
        openCode.value = false
    }

    // 获取扫码回调
    const onDecode = async (data: string[]): Promise<void> => {
        openCode.value = false
        let res = await getBarcodeContent({
            barcode: data[0]
        })
        if (res.code === 200) {
            if (res.data.barcodeType === QRCodeType.GZ) {
                // 查看是否已有工装
                for (let i = 0; i < list.value.length; i++) {
                    if (list.value[i].id === res.data.id) {
                        Toast.fail({ message: '不能扫描重复的工装' })
                        return
                    }
                }
                // 获取工装详情
                let lk = await getListByCondition({ id: res.data.id })
                if (lk.code === 200) {
                    if (lk.data[0].qualityType === 1) {
                        let next: boolean = false
                        for(let i = 0; i < list.value.length; i++) {    // 物料、工序、仓库一致才可以添加
                            if (list.value[0].mmodelCode === lk.data[0].mmodelCode && list.value[0].procedureId === lk.data[0].procedureId && list.value[0].warehouseId === lk.data[0].warehouseId) {
                                next = true
                            }
                        }
                        if (next) {
                            list.value.push(lk.data[0])
                        } else {
                            Toast.fail({ message: '扫描的工装物料、工序、仓库必须一致' })
                        }
                    } else {
                        Toast.fail({ message: '请扫描质量属性为不良的工装', duration: 2000 })
                    }
                }
            } else {
                Toast.fail({ message: '请扫描正确的工装码' })
            }
        }

    }

    const open = (): void => {
        openCode.value = true
    }

    // 获取工装信息
    const getLKInfo = async (id: string | number): Promise<void> => {
        let res = await getListByCondition({ id })
        if (res.code === 200) {
            if (res.data[0].qualityType === 1) {
                list.value.push(res.data[0])
                await getGXInfo(res.data[0].pmodelOrgId)
            } else {
                Toast.fail({ message: '请扫描质量属性为不良的工装', duration: 2000 })
            }
        }
    }

    // 获工序信息
    const getGXInfo = async (id: string): Promise<void> => {
        let res = await productesGroups({ orgId: id })
        if (res.code === 200) {
            res.data.forEach((item: any) => {
                columns1.value.push({ text: item.name, id: item.id })
            })
        }
    }

    // 返工返修不良原因
    const getBLInfo = async (id: string | number): Promise<void> => {
        let ids = ref<Array<string>>([])
        if (!id) {
            list.value.forEach((item: any) => {
                ids.value.push(item.id)
            })
        }
        let res = await checkFGFXList({ applianceids: id ? id : ids.value.join(',') })
        if (res.code === 200) {
            columns2.value = []
            res.data.forEach((item: any) => {
                columns2.value.push({ text: item.combinationName, id: item.id })
            })
            columns2.value.unshift({ text: '详见产品手写标签', id: '详见产品手写标签' })
            openYY.value = true
        }
    }

    // 查询所有单号
    const getDHInfo = async (): Promise<void> => {
        let res = await allData({})
        if (res.code === 200) {
            // console.log(res)
            res.data.forEach((item: any) => {
                columns3.value.push({ text: item.name, id: item.id })
            })
        }
    }

    onMounted(() => {
        getLKInfo(route.query.id as string)
        // getGXInfo()
        // getBLInfo(route.query.id as string)
        // getDHInfo()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_calendar = _resolveComponent("van-calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(form).type !== 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(list).length > 0 ? _unref(list)[0].dpmodelName : ''), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "rework_list_item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(show) //@ts-ignore
 ? show.value = true : show = true))
      }, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", {
            class: _normalizeClass(_unref(form).typeName ? 'black' : '')
          }, _toDisplayString(_unref(form).typeName ? _unref(form).typeName : '请点击选择类型'), 3),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20",
            color: "#999999"
          })
        ])
      ]),
      _createElementVNode("div", {
        class: "rework_list_item",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(openDate) //@ts-ignore
 ? openDate.value = true : openDate = true))
      }, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", {
            class: _normalizeClass(_unref(form).date ? 'black' : '')
          }, _toDisplayString(_unref(form).date ? _unref(form).date : '请点击选择日期'), 3),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20",
            color: "#999999"
          })
        ])
      ]),
      _createElementVNode("div", {
        class: "rework_list_item",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(openGX) //@ts-ignore
 ? openGX.value = true : openGX = true))
      }, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", {
            class: _normalizeClass(_unref(form).processName ? 'black' : '')
          }, _toDisplayString(_unref(form).processName ? _unref(form).processName : '请点击选择工序'), 3),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20",
            color: "#999999"
          })
        ])
      ]),
      _createElementVNode("div", {
        class: "rework_list_item",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (getBLInfo('')))
      }, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", {
            class: _normalizeClass(_unref(form).reasonName ? 'black' : '')
          }, _toDisplayString(_unref(form).reasonName ? _unref(form).reasonName : '请点击选择原因'), 3),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20",
            color: "#999999"
          })
        ])
      ]),
      (_unref(form).type === 3)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "rework_list_item",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_isRef(openDH) //@ts-ignore
 ? openDH.value = true : openDH = true))
          }, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", {
                class: _normalizeClass(_unref(form).singleName ? 'black' : '')
              }, _toDisplayString(_unref(form).singleName ? _unref(form).singleName : '请点击选择单号'), 3),
              _createVNode(_component_van_icon, {
                name: "arrow",
                size: "20",
                color: "#999999"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(form).type === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(form).clientName), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("span", null, "返工工装清单(" + _toDisplayString(_unref(list).length) + ")", 1)
      ]),
      (_unref(list).length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(list), (item, index) => {
            return (_openBlock(), _createBlock(_component_van_swipe_cell, {
              key: item.id
            }, {
              right: _withCtx(() => [
                _createVNode(_component_van_button, {
                  style: {"height":"100%"},
                  square: "",
                  type: "danger",
                  text: "删除",
                  onClick: ($event: any) => (dele(index))
                }, null, 8, ["onClick"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(item.code) + "：", 1),
                    _createElementVNode("span", _hoisted_27, _toDisplayString(item.num) + _toDisplayString(item.umodelName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("span", null, _toDisplayString(item.mmodelName) + " | " + _toDisplayString(item.mmodelCode), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("span", null, _toDisplayString(item.batch), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("span", null, _toDisplayString(item.pmodelName), 1)
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        : (_openBlock(), _createElementBlock("div", _hoisted_34, "暂无数据"))
    ]),
    _hoisted_35,
    _createElementVNode("div", { class: "rework_footer" }, [
      _createElementVNode("div", {
        class: "rework_footer_add",
        onClick: open
      }, "扫码添加工装"),
      _hoisted_36,
      _createElementVNode("button", {
        class: "rework_footer_submit",
        onClick: submit
      }, "提交")
    ]),
    _createVNode(_component_v_ScanCode, {
      openCode: _unref(openCode),
      infos: ['请扫描工装码'],
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode"]),
    _createVNode(_component_van_popup, {
      show: _unref(show),
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (_isRef(show) ? (show).value = $event : show = $event)),
      position: "bottom",
      round: "",
      style: { height: '45%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "请选择类型",
          columns: columns,
          onConfirm: onConfirm,
          onCancel: onCancel
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_calendar, {
      show: _unref(openDate),
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (_isRef(openDate) ? (openDate).value = $event : openDate = $event)),
      color: "#4275FC",
      "min-date": _unref(minDate),
      "max-date": _unref(maxDate),
      onConfirm: onConfirmDate
    }, null, 8, ["show", "min-date", "max-date"]),
    _createVNode(_component_van_popup, {
      show: _unref(openGX),
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => (_isRef(openGX) ? (openGX).value = $event : openGX = $event)),
      position: "bottom",
      round: "",
      style: { height: '45%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "请选择工序",
          columns: columns1.value,
          onConfirm: onConfirm1,
          onCancel: onCancel1
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _unref(openYY),
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => (_isRef(openYY) ? (openYY).value = $event : openYY = $event)),
      position: "bottom",
      round: "",
      style: { height: '45%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "请选择原因",
          columns: columns2.value,
          onConfirm: onConfirm2,
          onCancel: onCancel2
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _unref(openDH),
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => (_isRef(openDH) ? (openDH).value = $event : openDH = $event)),
      position: "bottom",
      round: "",
      style: { height: '45%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "请选择单号",
          columns: columns3.value,
          onConfirm: onConfirm3,
          onCancel: onCancel3
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})